export default "__VITE_ASSET__BSlZcGbx__"